import { Box, Container, Grid, makeStyles, Typography } from "@material-ui/core";
import * as React from "react";
import VehicleTabs from "../component/header/VehicleTabs";
import VehicleContent from "../component/header/VehicleContent";
import useVehicleTabs from "../hooks/useVehicleTabs";
import ContentLeft from "../component/ContentLeft";
import ContentRight from "../component/homePage/ContentRight";
import ImageSlider from "../component/header/ImageSlider";
import transit from '../assets/image/slick/ford-transit-desktop.webp';
import territory from '../assets/image/slick/territory-desktop-tab.webp';
import explorer from '../assets/image/slick/explorer-desktop-tab - Copy.webp';
import everest from '../assets/image/slick/ford-everest-desktop - Copy.webp';
import ranger from '../assets/image/slick/ford-ranger-stormtrak-desktop.webp';
import rapter from '../assets/image/slick/raptor-desktop-tab - Copy.webp';
import territory2025 from '../assets/image/slick/territory-tab-desktop.webp';
import YeuCauBaoGiaModal from "../modal/YeuCauBaoGiaModal";
const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: theme.spacing(8),
    },
    vehicleTab: {
        marginBottom: theme.spacing(4), // Thêm khoảng cách bên dưới tab xe
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    }
}));


export default function HomePage() {
    const classes = useStyles();
    const { selectedTab, handleTabChange, value } = useVehicleTabs();

    const imageList = [
        ranger,
        territory2025,
        explorer,
        everest,
        rapter,
        transit,
    ];

    const [isModalOpenYeuCauBaoGia, setIsModalOpenYeuCauBaoGia] = React.useState(true);
    const handleCloseModalYeuCauBaoGia = () => {
        setIsModalOpenYeuCauBaoGia(false);
    };
    return (
        <>
            <Box>
                <ImageSlider images={imageList} />
            </Box>
            <Container maxWidth="lg" className={classes.container}>
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className={classes.vehicleTab}>
                        <Typography variant="h3">
                            Khám phá các dòng xe
                        </Typography>
                        <VehicleTabs onChange={handleTabChange} value={value} />
                        <VehicleContent selectedVehicle={selectedTab} />
                    </Grid>
                </Grid>
            </Container>
            <Container maxWidth="lg">
                <Grid container spacing={2}>
                    <Grid item md={3} xs={12} >
                        <ContentLeft />
                    </Grid>
                    <Grid item md={9} xs={12} >
                        <ContentRight />
                    </Grid>
                </Grid>
            </Container>
            <YeuCauBaoGiaModal
                open={isModalOpenYeuCauBaoGia}
                onClose={handleCloseModalYeuCauBaoGia}
            />
        </>

    );
}